import { onMounted, onUnmounted } from "vue";

export function useRobotsMetaOverride(content: string) {
  let robotsMetaObserver: MutationObserver | null = null;

  const syncRobotsMeta = () => {
    if (typeof document === "undefined") return;

    const robotsMetaTags = document.head.querySelectorAll('meta[name="robots"]');

    if (robotsMetaTags.length === 0) {
      const robotsMeta = document.createElement("meta");
      robotsMeta.setAttribute("name", "robots");
      robotsMeta.setAttribute("content", content);
      document.head.appendChild(robotsMeta);
      return;
    }

    robotsMetaTags.forEach((metaTag) => {
      if (metaTag.getAttribute("content") !== content) {
        metaTag.setAttribute("content", content);
      }
    });
  };

  onMounted(() => {
    syncRobotsMeta();

    robotsMetaObserver = new MutationObserver(() => {
      syncRobotsMeta();
    });

    robotsMetaObserver.observe(document.head, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["content", "name"],
    });
  });

  onUnmounted(() => {
    if (robotsMetaObserver) {
      robotsMetaObserver.disconnect();
      robotsMetaObserver = null;
    }
  });
}